<template>
  <ScrollingBox
    section-id="benefits"
    :section-title="sectionTitle"
    :section-subtitle="sectionSubtitle"
    :section-description="sectionDescription"
    :data="benefits"
    button-text="Apply now"
    class="benefits"
  />
</template>

<script>
import ScrollingBox from '../shared/ScrollingBox/ScrollingBox.vue';

export default {
  components: { ScrollingBox },
  data() {
    return {
      sectionTitle: 'What makes Proxify different?',
      sectionSubtitle: 'Not another gig platform. A career network.',
      sectionDescription:
        'Most platforms offer the dream of flexibility, but they rarely lead to truly rewarding, career-building work. ' +
        "Proxify isn't just a place to find remote work. It’s a network built around long-term success for both tech talent and clients. " +
        'And while you focus on what you do best, we handle the paperwork, compliance, and payroll. No hassle. Fully reliable.',
      benefits: [
        {
          illustration: '/images/home-page/benefits/globe.svg',
          title: 'Remote, but grounded',
          description:
            'You can live anywhere within +4GMT to -10GMT time zones, but the work is serious. ' +
            "This isn't about juggling multiple side projects or working from the beach. " +
            "It's about access to meaningful opportunities, wherever you call home.",
        },
        {
          illustration: '/images/home-page/benefits/puzzle.svg',
          title: 'Fair credit. Real rewards. No politics.',
          description:
            "We're building the first developer network that tracks and rewards top performers, not billable hours. " +
            "When you do great work, you'll gain more visibility, better clients, and higher pay. It's entirely up to you.",
        },
        {
          illustration: '/images/home-page/benefits/money.svg',
          title: 'You always get paid. No uncertainty.',
          description:
            'You focus on the work. We handle billing and payments, and you get paid on time, every time. ' +
            "Even if the client hasn't paid us yet, your income is never at risk. That’s peace of mind you can count on.",
        },
        {
          illustration: '/images/home-page/benefits/long-term.svg',
          title: 'A long-term career, not just hotfixes',
          description:
            'We focus on lasting engagements where you become part of the team. ' +
            'Many of our professionals work with the same client for years, ' +
            'contributing to long-term goals and becoming an integral part of the team.',
        },
        {
          illustration: '/images/home-page/benefits/avatar.svg',
          title: 'Embedded, not detached',
          description:
            "You won't be just a name in a Jira story. You'll join real teams, build real products, " +
            'and form the kind of working relationships that help you grow both professionally and personally.',
        },
        {
          illustration: '/images/home-page/benefits/no-strings-attached.svg',
          title: 'No strings attached',
          description:
            'If you and a client want to transition to an in-house setup, we support that. ' +
            'They can move you to their payroll through a clear process that includes a fair one-time fee. ' +
            "It's a smooth handover that benefits everyone, especially you.",
        },
      ],
    };
  },
};
</script>
